import { PropsWithChildren, createContext, useContext } from 'react'
import dayjs from 'dayjs'
import MaterialIcon from './MaterialIcon'

type MainProps = {
  filters: Record<string, string | number>
  removeFilter: (key: string) => void
}

const PillContext = createContext<MainProps | undefined>(undefined)

export function PillFilters({
  filters,
  removeFilter,
  children,
}: PropsWithChildren<MainProps>) {
  return (
    <PillContext.Provider value={{ filters, removeFilter }}>
      {children}
    </PillContext.Provider>
  )
}

// Le date dei filtri (YYYY-MM-DD) sono mostrate nel formato italiano
function formatValue(value: string | number) {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? dayjs(value).format('DD/MM/YYYY')
    : value
}

type AutoPillProps = {
  label?: string
  caption?: string
  name: string
}

export function AutoFilter({ label, caption, name }: AutoPillProps) {
  const ctx = useContext(PillContext)

  if (!ctx) {
    return null
  }

  const { filters, removeFilter } = ctx

  if (!filters[name]) {
    return null
  }

  return (
    <span
      className="badge bg-secondary d-flex align-items-center pointer filter-pill"
      onClick={() => removeFilter(name)}
    >
      {caption ?? `${label}: ${formatValue(filters[name])}`}
      <MaterialIcon icon="close" fontSize={12} className="ms-2" />
    </span>
  )
}

type PillProps = {
  label: string
  onClick: () => void
}

export function PillFilter({ label, onClick }: PillProps) {
  return (
    <span
      className="badge bg-secondary d-flex align-items-center pointer filter-pill"
      onClick={onClick}
    >
      {label}
      <MaterialIcon icon="close" fontSize={12} className="ms-2" />
    </span>
  )
}
